export default __webpack_public_path__ + "static/media/orchid_tracking-white.3b65bd1a.svg";